import Vue from 'vue'
import App from '../App.vue';
import Router from 'vue-router'
import index from '../components/index.vue'
import search from '../components/search.vue'
import iframe from '../components/iframe.vue'


Vue.use(Router)

export default new Router({
  routes: [
   {
      path: '/',
      name: 'index',
      component: index,
      meta:{
      	title:'轻护百科'
      }
    },
    {
      path: '/search',
      name: 'search',
      component: search,
      meta:{
      	title:'百科搜索'
      }
    },
    {
      path: '/iframe',
      name: 'iframe',
      component: iframe,
      meta:{
      	title:'文章'
      }
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js